import { render, staticRenderFns } from "./knowledgeBase.vue?vue&type=template&id=d71435fe&scoped=true"
import script from "./knowledgeBase.vue?vue&type=script&lang=js"
export * from "./knowledgeBase.vue?vue&type=script&lang=js"
import style0 from "./knowledgeBase.vue?vue&type=style&index=0&id=d71435fe&prod&scoped=true&lang=css"
import style1 from "./knowledgeBase.vue?vue&type=style&index=1&id=d71435fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71435fe",
  null
  
)

export default component.exports